import { Controller } from 'stimulus'
import { jsRequest } from '@react/helpers/fetch'

export default class extends Controller {
  static targets = [ 'container', 'modal' ]

  show(event) {
    if(this.loading) return

    const link = event.target.closest('[data-route]')
    if (!link) return

    this.loading = true
    const { method, route, size } = link.dataset
    const options = {
      callback:  this._callback.bind(this),
      onFailure: this._onFailure.bind(this)
    }
    if (method) options.method = method
    this.resize(size)
    this.load()

    if(route) jsRequest(route, options)
    else this.loading = false
  }

  load() {
    if (!this.hasModalTarget) return

    const spinnerHTML =
    `
      <div class="loading-spinner-container">
        <div id="loading-spinner"></div>
      </div>
    `
    this.modalTarget.innerHTML = spinnerHTML
  }

  // Private methods

  // Without this a single failed request leaves the controller loading for
  // good, swallowing every later click while the modal keeps spinning.
  _onFailure() {
    this.loading = false
    if (!this.hasModalTarget) return

    const offline = window.navigator.onLine === false
    this.modalTarget.innerHTML = `
      <div class="modal-request-error">
        <div class="love-notice love-notice--error">
          <i class="fas fa-exclamation-triangle"></i>
          <span>${I18n.t(offline ? 'errors.messages.offline' : 'errors.messages.oops')}</span>
        </div>
        <p>${I18n.t('errors.messages.retry_later')}</p>
      </div>
    `
  }

  _callback() {
    if (this.hasModalTarget)
      reloadReact(this.modalTarget)
    else {
      reloadReact(this.element)
    }
    this.loading = false
  }

  resize(size) {
    if (!this.hasContainerTarget) return

    this.containerTarget.classList.remove("modal-lg")
    this.containerTarget.classList.remove("modal-xl")
    this.containerTarget.classList.remove("modal-sm")

    const sizeClass = this._getSizeClass(size)

    if (sizeClass) this.containerTarget.classList.add(sizeClass)
  }

  _getSizeClass(size) {
    switch (size) {
      case 'xl':     return "modal-xl"
      case 'small':  return "modal-sm"
      case 'medium': return ""
      default:       return "modal-lg"
    }
  }
}
